<template>
  <Modal position="end" ref="modalRef" @after-close="clearForm">
    <template #header>Edit agent</template>

    <template #body>
      <FormGroup>
        <FormField label="Showing will be held by" :error="form.fieldErrors('showingAgentId')">
          <ShowingAgentPicker v-model="form.fields.showingAgentId" />
        </FormField>
      </FormGroup>
    </template>

    <template #footer>
      <Button variant="ghost" @click="close">Cancel</Button>
      <Button :loading="isLoading" @click="save">Save</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { helpers, required } from '@vuelidate/validators';
import { ref } from 'vue';

import { Button, FormField, FormGroup, Modal, useAlertsStore, useForm } from '@tallo/design-system';
import { useAssignShowingAgent } from '@tallo/investor/showing';
import { ShowingAgentPicker } from '@tallo/investor/showing-agents';

const props = defineProps<{
  showingId: string;
  showingAgentId: string;
}>();

const alertStore = useAlertsStore();
const { mutateAsync, isLoading } = useAssignShowingAgent();

const modalRef = ref<InstanceType<typeof Modal> | null>(null);
const form = useForm<{ showingAgentId: string }>(
  {
    showingAgentId: props.showingAgentId,
  },
  {
    showingAgentId: { required: helpers.withMessage('Showing agent is required', required) },
  },
);

function open() {
  modalRef.value?.show();
}

function close() {
  modalRef.value?.close();
}

function clearForm() {
  form.resetValidation();
}

async function save() {
  form.submit(async () => {
    try {
      await mutateAsync({ showingId: props.showingId, showingAgentId: form.fields.showingAgentId });

      close();
    } catch (error) {
      alertStore.catchError(error);
    }
  });
}

defineExpose({ open });
</script>
